'use client';

import { useRouter } from 'next/navigation';
import { signOut, useSession } from 'next-auth/react';
import { ReactNode, useEffect } from 'react';

import { HOME_PAGE_ROUTE } from '~/definitions/routes';

interface AuthErrorHandlerProps {
  children: ReactNode;
  routesMatcher?: string[];
}

export const AuthErrorHandler = ({ children }: AuthErrorHandlerProps) => {
  const { data } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (data?.user.token.error) {
      signOut({ callbackUrl: HOME_PAGE_ROUTE });
    }
  }, [data?.user.token.error, router]);

  return <>{children}</>;
};
